import React, { useState } from "react";
import { useHistory } from "react-router-dom";

export default function Login() {
  const history = useHistory();
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage(""); 
    setIsLoading(true); 

    if (!login || !senha) {
      setErrorMessage("Por favor, preencha todos os campos.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch("https://api.lc-transportes.com/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ login, senha }),
      });

      const data = await response.json();

      if (response.ok) {

        localStorage.setItem("cargo", data.data.role);
        localStorage.setItem("id", data.data.id);
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("nome", data.data.nome);
        localStorage.setItem("telefone", data.data.telefone);
        localStorage.setItem("email", data.data.email);
        localStorage.setItem("cpf", data.data.cpf);
        localStorage.setItem("fist", 0);

        const bases = data.data.bases || [];
        if (bases.length > 0) {
          localStorage.setItem("bases", JSON.stringify(bases));
          localStorage.setItem("baseSelected", bases[0].id);
        } else {
          setErrorMessage("Nenhuma base encontrada para este usuário.");
          setIsLoading(false);
          return;
        }
        
        if (data.data.role === "MOTORISTA") {
          history.push(`/motorista`);
        } else {
         history.push(`/admin`);
        }
        
      } else {
        setErrorMessage(data.message || "Erro ao fazer login. Verifique seus dados.");
      }
    } catch (error) {
      setErrorMessage("Erro ao fazer login. Verifique seus dados.");
    } finally {
      setIsLoading(false); 
    }
  };

  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <img src="/apple-icon.png" alt="Ícone" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form onSubmit={handleSubmit}>
                  {/* Exibição de mensagem de erro */}
                  {errorMessage && (
                    <div className="text-red-500 text-sm mb-4 text-center">
                      {errorMessage}
                    </div>
                  )}

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="login"
                    >
                      Login
                    </label>
                    <input
                      type="text"
                      id="login"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Login"
                      value={login}
                      onChange={(e) => setLogin(e.target.value)}
                      required
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="senha"
                    >
                      Senha
                    </label>
                    <input
                      type="password"
                      id="senha"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Senha"
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                      required
                    />
                  </div>

                  <div className="text-center mt-6">
                    <button
                      className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 flex justify-center items-center"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        "Entrando..."
                      ) : (
                        "Entrar"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
